import { render, staticRenderFns } from "./SingpassOnboarding.vue?vue&type=template&id=e502e556&"
import script from "./SingpassOnboarding.vue?vue&type=script&lang=js&"
export * from "./SingpassOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./SingpassOnboarding.vue?vue&type=style&index=0&id=e502e556&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports